import React, { PropsWithChildren } from "react";
import styles from "./heading.module.scss";

export function Heading(props: PropsWithChildren<unknown>): JSX.Element {
  return <h3 className={styles.heading}>{props.children}</h3>;
}
